import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getPerson, updatePerson } from "../../actions/personActions";
import Grid from "@material-ui/core/Grid";
import Form from "./Form";
import InputElement from "../InputElement";
import { FormMode, InputElementType } from "../../types/enums";

const UpdatePersonForm = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [street, setStreet] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [city, setCity] = useState("");

  const [isFetching, setIsFetching] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(async () => {
    try {
      setIsFetching(true);
      const response = await getPerson(this.props.id);
      setFirstName(response.firstName);
      setLastName(response.lastName);
      setEmail(response.email);
      setPhone(response.phone);
      setStreet(response.street);
      setStreetNumber(response.streetNumber);
      setZipcode(response.zipcode);
      setCity(response.city);
      setSuccessMessage("");
    } catch (error) {
      setErrorMessage(error);
    } finally {
      setIsFetching(false);
    }
  }, []);

  const updateUser = async () => {
    try {
      setIsFetching(true);
      await updatePerson(this.props.id, this.state);
      setSuccessMessage("Bijwerken is voltooid");
    } catch (error) {
      setErrorMessage(error);
    } finally {
      setIsFetching(false);
    }
  };

  const inputs = [
    {
      id: "firstName",
      type: InputElementType.TEXT,
      label: "Naam *",
      state: firstName,
      setState: setFirstName,
    },
    {
      id: "lastName",
      type: InputElementType.TEXT,
      label: "Naam *",
      state: lastName,
      setState: setLastName,
    },
    {
      id: "email",
      type: InputElementType.TEXT,
      label: "E-mailadres *",
      state: email,
      setState: setEmail,
    },

    {
      id: "phone",
      type: InputElementType.TEXT,
      label: "Telefoonnummer *",
      state: phone,
      setState: setPhone,
    },
    {
      id: "street",
      type: InputElementType.TEXT,
      label: "Adres *",
      state: street,
      setState: setStreet,
    },
    {
      id: "streetNumber",
      type: InputElementType.TEXT,
      label: "Huisnr. *",
      state: streetNumber,
      setState: setStreetNumber,
    },
    {
      id: "zipcode",
      type: InputElementType.TEXT,
      label: "Postcode *",
      state: zipcode,
      setState: setZipcode,
    },
    {
      id: "city",
      type: InputElementType.TEXT,
      label: "Plaats *",
      state: city,
      setState: setCity,
    },
  ];

  return (
    <Form
      onSubmit={updateUser}
      submitText={"Wijzigen"}
      isFetching={isFetching}
      successMessage={successMessage}
      errorMessage={errorMessage}
      mode={FormMode.UPDATE}
    >
      <Grid container spacing={3}>
        {inputs.map((i) => (
          <InputElement key={i.id} item={i} />
        ))}
      </Grid>
    </Form>
  );
};

UpdatePersonForm.propTypes = {
  id: PropTypes.string.isRequired,
};

export default UpdatePersonForm;



// WEBPACK FOOTER //
// ./src/components/forms/UpdatePersonForm.js